module.exports = __webpack_public_path__ + "static/media/2.14.c35e3a4f.png";